import { MaxLengthValidatorDirective } from '../../shared/directives/max-length-validator.directive';
import { Component, OnInit, inject } from '@angular/core';
import { RouterLink, ActivatedRoute } from '@angular/router';
import { FormsModule, NgForm } from '@angular/forms';
import { PageTitleService } from '../../core/services/page-title.service';
import { StudioService } from '../../core/services/studio.service';
import { OwnerService } from '../../core/services/owner.service';
import { AuthStateService } from '../../core/services/auth-state.service';
import { MemberService } from '../../core/services/member.service';
import { FlashService } from '../../core/services/flash.service';
import { FlashMessageComponent } from '../../shared/components/flash-message.component';

@Component({
    selector: 'app-studio-edit',
    imports: [MaxLengthValidatorDirective, RouterLink, FormsModule, FlashMessageComponent],
    template: `
<div class="animated fadeIn">
  <div class="row sfapp-container">
    <div class="col-md-12">
      <div class="card">
        <div class="card-header">
          <span><i class="fa s-icon-edit"></i>&nbsp;編集</span>
        </div>
        <div class="card-body">
          <!-- 旧版 studio-edit.html:9-12 の card-body 先頭 <flash-message> 相当 -->
          <div class="col-md-12"><app-flash-message></app-flash-message></div>
            @if (loading) {
              <div class="text-center py-3"><span class="fa fa-spinner fa-spin fa-2x"></span></div>
            }
            @if (!loading) {
              <form novalidate name="studioBaseEditForm" #studioBaseEditForm="ngForm" (ngSubmit)="save(studioBaseEditForm)">
                <div class="col-md-12">
                  @if (canManageStudioSettings) {
                  <div class="form-group row">
                    <div class="col-md-6">
                      <label class="col-form-label">所属(FCオーナー)</label>
                      <select class="form-control" [(ngModel)]="form.ownerId" name="ownerId" required>
                        <option value="">選択してください</option>
                        @for (o of owners; track o.id) {
                          <option [ngValue]="o.id">{{ o.name }}</option>
                        }
                      </select>
                    </div>
                  </div>
                  <div class="form-group row">
                    <div class="col-md-6">
                      <label class="col-form-label">口座振替連携先</label>
                      <select class="form-control" [(ngModel)]="form.btMethod" name="btMethod" required>
                        <option value="">選択してください</option>
                        <option value="2">りそな</option>
                        <option value="1">アプラス</option>
                      </select>
                    </div>
                  </div>
                  <div class="form-group row">
                    <div class="col-md-6">
                      <label class="col-form-label">口座振替用顧客ID@if (form.btMethod == '1') {<span>（りそな用）</span>}</label>
                      <input type="text" class="form-control" [(ngModel)]="form.trusteeCode" name="trusteeCode" pattern="^[0-9]+$" required>
                      @if (form.btMethod == '1') {
                        <small class="form-text text-muted">アプラスは固定値: 32368</small>
                      }
                    </div>
                  </div>
                  <div class="form-group row">
                    <div class="col-md-6">
                      <label class="col-form-label">りそなオンライン口座登録（入会ページ）</label>
                      <div class="custom-control custom-radio">
                        <div class="custom-control custom-radio custom-control-inline">
                          <input type="radio" id="bt_payment_enabled_1" class="custom-control-input" [(ngModel)]="form.btPaymentEnabled" name="btPaymentEnabled" value="1">
                          <label class="custom-control-label" for="bt_payment_enabled_1">有効</label>
                        </div>
                        <div class="custom-control custom-radio custom-control-inline">
                          <input type="radio" id="bt_payment_enabled_0" class="custom-control-input" [(ngModel)]="form.btPaymentEnabled" name="btPaymentEnabled" value="0">
                          <label class="custom-control-label" for="bt_payment_enabled_0">無効</label>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="form-group row">
                    <div class="col-md-6">
                      <label class="col-form-label">りそなオンライン口座登録（管理画面）</label>
                      <div class="custom-control custom-radio">
                        <div class="custom-control custom-radio custom-control-inline">
                          <input type="radio" id="bt_payment_enabled_admin_1" class="custom-control-input" [(ngModel)]="form.btPaymentEnabledAdmin" name="btPaymentEnabledAdmin" value="1">
                          <label class="custom-control-label" for="bt_payment_enabled_admin_1">有効</label>
                        </div>
                        <div class="custom-control custom-radio custom-control-inline">
                          <input type="radio" id="bt_payment_enabled_admin_0" class="custom-control-input" [(ngModel)]="form.btPaymentEnabledAdmin" name="btPaymentEnabledAdmin" value="0">
                          <label class="custom-control-label" for="bt_payment_enabled_admin_0">無効</label>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="form-group row">
                    <div class="col-md-6">
                      <label class="col-form-label">りそなオンライン口座登録（マイページ）</label>
                      <div class="custom-control custom-radio">
                        <div class="custom-control custom-radio custom-control-inline">
                          <input type="radio" id="bt_payment_enabled_mypage_1" class="custom-control-input" [(ngModel)]="form.btPaymentEnabledMypage" name="btPaymentEnabledMypage" value="1">
                          <label class="custom-control-label" for="bt_payment_enabled_mypage_1">有効</label>
                        </div>
                        <div class="custom-control custom-radio custom-control-inline">
                          <input type="radio" id="bt_payment_enabled_mypage_0" class="custom-control-input" [(ngModel)]="form.btPaymentEnabledMypage" name="btPaymentEnabledMypage" value="0">
                          <label class="custom-control-label" for="bt_payment_enabled_mypage_0">無効</label>
                        </div>
                      </div>
                    </div>
                  </div>
                  }
                  <div class="form-group row">
                    <div class="col-md-6">
                      <label class="col-form-label">店舗名</label>
                      <input type="text" class="form-control" [(ngModel)]="form.name" name="name" required>
                    </div>
                  </div>
                  @if (form.ownerId != 1) {
                    <div class="form-group row">
                      <div class="col-md-6">
                        <label class="col-form-label">領収書表示名</label>
                        <input type="text" class="form-control" [(ngModel)]="form.receiptName" name="receiptName">
                      </div>
                    </div>
                  }
                  <div class="form-group row">
                    <div class="col-md-6">
                      <label class="col-form-label">表示ID</label>
                      <input type="text" class="form-control" [(ngModel)]="form.sortBy" name="sortBy" required>
                    </div>
                  </div>
                  <div class="row">
                    <div class="form-group col-md-6">
                      <label class="col-form-label">郵便番号</label>
                      <div class="bisected-input-wrap">
                        <div class="bisected-input">
                          <input type="text" class="form-control" [(ngModel)]="form.zip1" name="zip1" pattern="^[\\x01-\\x7E]+$" required>
                        </div>
                        <span>&nbsp;</span>
                        <div class="bisected-input">
                          <input type="text" class="form-control" [(ngModel)]="form.zip2" name="zip2" pattern="^[\\x01-\\x7E]+$" required>
                        </div>
                      </div>
                    </div>
                    <div class="form-group col-md-6 d-flex align-items-end">
                      <button type="button" class="btn btn-primary text-white" (click)="searchZipCode()"><i class="fa s-icon-autoAddress"></i>&nbsp;住所自動入力</button>
                    </div>
                  </div>
                  <div class="form-group row">
                    <div class="col-md-12">
                      <label class="col-form-label">住所</label>
                      <div class="quartered-input-wrap">
                        <div class="quartered-input">
                          <input type="text" class="form-control" [(ngModel)]="form.province" name="province" required>
                        </div>
                        <span>&nbsp;</span>
                        <div class="quartered-input">
                          <input type="text" class="form-control" [(ngModel)]="form.city" name="city" required>
                        </div>
                        <span>&nbsp;</span>
                        <div class="quartered-input">
                          <input type="text" class="form-control" [(ngModel)]="form.area" name="area" required>
                        </div>
                        <span>&nbsp;</span>
                        <div class="quartered-input">
                          <input type="text" class="form-control" [(ngModel)]="form.address" name="address">
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="form-group row">
                    <div class="col-md-6">
                      <label class="col-form-label">地区</label>
                      <select class="form-control" [(ngModel)]="form.localNumber" name="localNumber">
                        <option value="">選択してください</option>
                        @for (l of localNumbers; track l.localNumber) {
                          <option [value]="l.localNumber">{{ l.name }}</option>
                        }
                      </select>
                    </div>
                  </div>
                  <div class="form-group row">
                    <div class="col-md-6">
                      <label class="col-form-label">電話番号</label>
                      <div class="trisection-input-wrap">
                        <div class="trisection-input">
                          <input type="text" class="form-control" [(ngModel)]="form.phone1" name="phone1" pattern="^[\\x01-\\x7E]+$" required>
                        </div>
                        <span>&nbsp;</span>
                        <div class="trisection-input">
                          <input type="text" class="form-control" [(ngModel)]="form.phone2" name="phone2" pattern="^[\\x01-\\x7E]+$" required>
                        </div>
                        <span>&nbsp;</span>
                        <div class="trisection-input">
                          <input type="text" class="form-control" [(ngModel)]="form.phone3" name="phone3" pattern="^[\\x01-\\x7E]+$" required>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="form-group row">
                    <div class="col-md-6">
                      <label class="col-form-label">メールアドレス</label>
                      <input type="email" class="form-control" [(ngModel)]="form.email" name="email" pattern="^[\\x01-\\x7E]+$" email required>
                    </div>
                  </div>
                  @if (canManageStudioSettings) {
                  <div class="form-group row">
                    <div class="col-md-12">
                      <label class="col-form-label">お申し込みページに利用開始日の選択を表示する</label>
                      <div class="custom-control custom-radio">
                        <div class="custom-control custom-radio custom-control-inline">
                          <input type="radio" id="is_unmanned_1" class="custom-control-input" [(ngModel)]="form.isUnmanned" name="isUnmanned" value="1">
                          <label class="custom-control-label" for="is_unmanned_1">表示する</label>
                        </div>
                        <div class="custom-control custom-radio custom-control-inline">
                          <input type="radio" id="is_unmanned_0" class="custom-control-input" [(ngModel)]="form.isUnmanned" name="isUnmanned" value="0">
                          <label class="custom-control-label" for="is_unmanned_0">表示しない</label>
                        </div>
                      </div>
                    </div>
                  </div>
                  @if (form.isUnmanned == '1') {
                    <div class="form-group row">
                      <div class="col-md-12">
                        &emsp;<span class="material-icons-outlined" style="font-size: inherit;">info</span>
                        <span>選択された利用開始日を過ぎると、自動的に本登録処理が行われます。</span>
                      </div>
                      <div class="col-md-12">
                        &emsp;<span class="material-icons-outlined" style="font-size: inherit;">info</span>
                        <span>支払方法がクレジットカード以外の場合、利用開始日の選択は表示されません。</span>
                      </div>
                    </div>
                    <div class="form-group row">
                      <div class="col-md-12">
                        <label class="col-form-label">初回ご請求金額に関する注意事項</label>
                        <textarea type="text" class="form-control" rows="3" [(ngModel)]="form.note" name="note" placeholder="注意事項（255文字以内）" sfMaxLength="255"></textarea>
                      </div>
                    </div>
                  }
                  }
                  <div class="form-group row">
                    <div class="col-md-12">
                      <label class="col-form-label">お申し込みページ会員区分に「来館予約」を表示する</label>
                      <div class="custom-control custom-radio">
                        <div class="custom-control custom-radio custom-control-inline">
                          <input type="radio" id="is_displayed_tour_plan_1" class="custom-control-input" [(ngModel)]="form.isDisplayedTourPlan" name="isDisplayedTourPlan" value="1">
                          <label class="custom-control-label" for="is_displayed_tour_plan_1">表示する</label>
                        </div>
                        <div class="custom-control custom-radio custom-control-inline">
                          <input type="radio" id="is_displayed_tour_plan_0" class="custom-control-input" [(ngModel)]="form.isDisplayedTourPlan" name="isDisplayedTourPlan" value="0">
                          <label class="custom-control-label" for="is_displayed_tour_plan_0">表示しない</label>
                        </div>
                      </div>
                    </div>
                  </div>
                  @if (form.isDisplayedTourPlan == '1') {
                    <div class="form-group row">
                      <div class="col-md-12">
                        &emsp;<span class="material-icons-outlined" style="font-size: inherit;">info</span>
                        <span>予約管理 > メニュー 画面にて、有効な非会員向けメニューを1つ以上作成してください。</span>
                      </div>
                    </div>
                  }
                  <div class="form-group row">
                    <div class="col-md-12">
                      <label class="col-form-label">当日予約を許可する(来館予約/PT予約共通)</label>
                      <div class="custom-control custom-radio">
                        <div class="custom-control custom-radio custom-control-inline">
                          <input type="radio" id="reservation_offset_days_0" class="custom-control-input" [(ngModel)]="form.reservationOffsetDays" name="reservationOffsetDays" value="0">
                          <label class="custom-control-label" for="reservation_offset_days_0">許可する</label>
                        </div>
                        <div class="custom-control custom-radio custom-control-inline">
                          <input type="radio" id="reservation_offset_days_1" class="custom-control-input" [(ngModel)]="form.reservationOffsetDays" name="reservationOffsetDays" value="1">
                          <label class="custom-control-label" for="reservation_offset_days_1">許可しない</label>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="form-group row">
                    <div class="col-md-4">
                      <label class="col-form-label">当日予約の受付猶予</label>
                      <div class="d-flex align-items-baseline" style="gap: 10px">
                        <input type="number" min="0" max="12" class="form-control" style="max-width: 80%;" [(ngModel)]="form.reservationOffsetHours" name="reservationOffsetHours">
                        <span>時間</span>
                      </div>
                    </div>
                  </div>
                  @if (canManageStudioSettings) {
                  <div class="form-group row">
                    <div class="col-md-12">
                      <label class="col-form-label">お申し込みページに「クレジットカード入会リンク」を表示する</label>
                      <div class="custom-control custom-radio">
                        <div class="custom-control custom-radio custom-control-inline">
                          <input type="radio" id="is_displayed_cc_link_1" class="custom-control-input" [(ngModel)]="form.isDisplayedCcLink" name="isDisplayedCcLink" value="1">
                          <label class="custom-control-label" for="is_displayed_cc_link_1">表示する</label>
                        </div>
                        <div class="custom-control custom-radio custom-control-inline">
                          <input type="radio" id="is_displayed_cc_link_0" class="custom-control-input" [(ngModel)]="form.isDisplayedCcLink" name="isDisplayedCcLink" value="0">
                          <label class="custom-control-label" for="is_displayed_cc_link_0">表示しない</label>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="form-group row">
                    <div class="col-md-12">
                      <label class="col-form-label">会員登録メールのパターン選択</label>
                      <div class="custom-control custom-radio">
                        <div class="custom-control custom-radio custom-control-inline">
                          <input type="radio" id="registration_email_pattern_1" class="custom-control-input" [(ngModel)]="form.registrationEmailPattern" name="registrationEmailPattern" value="0">
                          <label class="custom-control-label" for="registration_email_pattern_1">通常</label>
                        </div>
                        <div class="custom-control custom-radio custom-control-inline">
                          <input type="radio" id="registration_email_pattern_3" class="custom-control-input" [(ngModel)]="form.registrationEmailPattern" name="registrationEmailPattern" value="2">
                          <label class="custom-control-label" for="registration_email_pattern_3">事前入会</label>
                        </div>
                      </div>
                    </div>
                  </div>
                  }
                  <div class="form-group row">
                    <div class="col-md-12">
                      <label class="col-form-label">カウンセリング</label>
                      <div class="custom-control custom-radio">
                        <div class="custom-control custom-radio custom-control-inline">
                          <input type="radio" id="is_counselable_1" class="custom-control-input" [(ngModel)]="form.isCounselable" name="isCounselable" value="1">
                          <label class="custom-control-label" for="is_counselable_1">実施する</label>
                        </div>
                        <div class="custom-control custom-radio custom-control-inline">
                          <input type="radio" id="is_counselable_0" class="custom-control-input" [(ngModel)]="form.isCounselable" name="isCounselable" value="0">
                          <label class="custom-control-label" for="is_counselable_0">実施しない</label>
                        </div>
                      </div>
                    </div>
                  </div>
                  @if (form.isCounselable == '1') {
                    <div class="form-group row">
                      <div class="col-md-12">
                        <label class="col-form-label">トレーニングメニュー画像</label>
                        <div class="custom-control custom-radio">
                          <div class="custom-control custom-radio custom-control-inline">
                            <input type="radio" id="is_machine_installed_1" class="custom-control-input" [(ngModel)]="form.isMachineInstalled" name="isMachineInstalled" value="1">
                            <label class="custom-control-label" for="is_machine_installed_1">ストレッチマシンあり</label>
                          </div>
                          <div class="custom-control custom-radio custom-control-inline">
                            <input type="radio" id="is_machine_installed_0" class="custom-control-input" [(ngModel)]="form.isMachineInstalled" name="isMachineInstalled" value="0">
                            <label class="custom-control-label" for="is_machine_installed_0">ストレッチマシン無し</label>
                          </div>
                          <div class="custom-control custom-radio custom-control-inline">
                            <input type="radio" id="is_machine_installed_2" class="custom-control-input" [(ngModel)]="form.isMachineInstalled" name="isMachineInstalled" value="2">
                            <label class="custom-control-label" for="is_machine_installed_2">オリジナルパターン</label>
                          </div>
                        </div>
                      </div>
                    </div>
                  }
                  <div class="form-group row">
                    <div class="col-md-4">
                      <label class="col-form-label">店舗面積（坪数）</label>
                      <input type="number" step="0.01" class="form-control" [(ngModel)]="form.floorArea" name="floorArea">
                    </div>
                  </div>
                  <div class="form-group row">
                    <div class="col-md-6">
                      <label class="col-form-label">入退館認証方式</label>
                      <select class="form-control" [(ngModel)]="form.inoutTypeId" name="inoutTypeId" required>
                        @for (opt of inoutTypeOptions; track opt.id) {
                          <option [value]="opt.id">{{ opt.name }}</option>
                        }
                      </select>
                    </div>
                  </div>
                  <div class="form-group row">
                    <div class="col-md-12 text-right">
                      <a routerLink="/studio" class="btn bg-close text-white"><i class="fa s-icon-cancel"></i>&nbsp;閉じる</a>
                      @if (canManageStudioSettings) {
                        <button type="submit" class="btn btn-success" [disabled]="saving || studioBaseEditForm.invalid || isInvalid()"><i class="fa s-icon-save"></i>&nbsp;保存</button>
                      }
                    </div>
                  </div>
                </div>
              </form>
            }
        </div>
      </div>
    </div>
  </div>
</div>
  `
})
export class StudioEditComponent implements OnInit {
  private pageTitleService = inject(PageTitleService);
  private studioService = inject(StudioService);
  private ownerService = inject(OwnerService);
  private authState = inject(AuthStateService);
  private memberService = inject(MemberService);
  private route = inject(ActivatedRoute);
  private flash = inject(FlashService);

  studioId!: number;
  form: any = {};
  owners: any[] = [];
  localNumbers: any[] = [];
  loading = true;
  saving = false;

  get userPermission(): number { return this.authState.currentUser?.role ?? 99; }
  get canManageStudioSettings(): boolean { return this.userPermission <= 10; }

  readonly inoutTypeOptions = [
    { name: '物理キー', id: '0' },
    { name: '顔認証', id: '1' },
    { name: '都度選択', id: '9' },
  ];

  async ngOnInit(): Promise<void> {
    this.pageTitleService.set('店舗管理', 's-icon-studio');
    this.studioId = +this.route.snapshot.params['studioId'];
    await this.loadStudio();
  }

  private async loadStudio(): Promise<void> {
    this.loading = true;
    try {
      const [data, owners, localNumbers]: any[] = await Promise.all([
        this.studioService.list(this.studioId),
        this.ownerService.list('all'),
        this.studioService.getLocalNumberList(),
      ]);
      this.owners = Array.isArray(owners) ? owners : [];
      this.localNumbers = Array.isArray(localNumbers) ? localNumbers : [];

      this.form = Array.isArray(data) ? (data[0] ?? { id: this.studioId }) : (data ?? { id: this.studioId });
      if (!this.form.id) this.form.id = this.studioId;

      const zip = this.form.zip ?? '';
      const zipParts = zip.split('-');
      this.form.zip1 = zipParts[0] ?? '';
      this.form.zip2 = zipParts[1] ?? '';

      const phone = this.form.phone ?? '';
      const phoneParts = phone.split('-');
      this.form.phone1 = phoneParts[0] ?? '';
      this.form.phone2 = phoneParts[1] ?? '';
      this.form.phone3 = phoneParts[2] ?? '';

      this.form.btMethod = String(this.form.btMethod ?? '');
      this.form.btPaymentEnabled = String(this.form.btPaymentEnabled ?? 0);
      this.form.btPaymentEnabledAdmin = String(this.form.btPaymentEnabledAdmin ?? 0);
      this.form.btPaymentEnabledMypage = String(this.form.btPaymentEnabledMypage ?? 0);
      this.form.isDisplayedTourPlan = String(this.form.isDisplayedTourPlan ?? 0);
      this.form.isDisplayedCcLink = String(this.form.isDisplayedCcLink ?? 0);
      this.form.isUnmanned = String(this.form.isUnmanned ?? 0);
      this.form.registrationEmailPattern = String(this.form.registrationEmailPattern ?? 0);
      this.form.isCounselable = String(this.form.isCounselable ?? 0);
      this.form.isMachineInstalled = String(this.form.isMachineInstalled ?? 0);
      this.form.reservationOffsetDays = String(this.form.reservationOffsetDays ?? 0);
      this.form.ownerId = this.form.owner?.id ?? this.form.ownerId;
      this.form.inoutTypeId = String(this.form.inoutType ?? '0');
      this.form.floorArea = this.form.floorArea ? parseFloat(this.form.floorArea) : null;
    } finally {
      this.loading = false;
    }
  }

  async searchZipCode(): Promise<void> {
    const zipCode = `${this.form.zip1 ?? ''}-${this.form.zip2 ?? ''}`;
    if (!zipCode || zipCode === '-') return;
    const address: any = await this.memberService.getAddress(zipCode);
    if (!address) return;
    this.form.province = address.address1;
    this.form.city = address.address2;
    this.form.area = address.address3;
    this.form.address = '';
  }

  isInvalid(): boolean {
    if (!this.form) return true;
    return ['ownerId', 'btMethod', 'trusteeCode', 'name', 'sortBy', 'zip1', 'zip2', 'province', 'city', 'area', 'phone1', 'phone2', 'phone3', 'email']
      .some(key => this.form[key] === null || this.form[key] === undefined || this.form[key] === '');
  }

  async save(form?: NgForm): Promise<void> {
    if (!this.canManageStudioSettings || form?.invalid || this.isInvalid()) {
      form?.control.markAllAsTouched();
      return;
    }
    this.saving = true;
    try {
      const json = { ...this.form };
      json.zip = `${json.zip1}-${json.zip2}`;
      json.phone = `${json.phone1}-${json.phone2}-${json.phone3}`;
      delete json.zip1; delete json.zip2;
      delete json.phone1; delete json.phone2; delete json.phone3;
      delete json.owner;
      delete json.studioFees;
      delete json.studioPlans;
      delete json.studioLockerPlans;
      delete json.createdAt;
      delete json.updatedAt;
      delete json.status;
      if (Number(json.ownerId) === 1) json.receiptName = '';
      json.inoutType = json.inoutTypeId;
      delete json.inoutTypeId;
      await this.studioService.upsert(json);
      // 旧版 studio.js:366-369: Flash「店舗基本情報を更新しました」、先頭へscroll、state reload（画面全体の再読込はしない）
      this.flash.create('success', '店舗基本情報を更新しました');
      window.scrollTo(0, 0);
      await this.loadStudio();
    } finally {
      this.saving = false;
    }
  }
}
